import { useEffect, useState } from 'react';

const RedReqList = () => {
  const val = JSON.parse(localStorage.getItem('userdata'));
  const permissions = val.tenant_nav_bar_permission;
  const [redReqPages, setRedReqPages] = useState([]);

  useEffect(() => {
    const updatedTenantPages = [];
    
    // Check if NEFT tab is completely disabled or enabled
    const showNeft = permissions?.is_neft_tab == 1 || permissions?.is_neft_tab === true || permissions?.is_neft_tab === '1' || permissions?.is_neft_tab == null;
    
    // The legacy is_redeem_request_tab used to mean NEFT, we require both to be true if is_neft_tab was explicitly added
    if ((permissions?.is_redeem_request_tab == 1 || permissions?.is_redeem_request_tab === true || permissions?.is_redeem_request_tab === '1') && showNeft) {
      updatedTenantPages.push(
        {
          name: 'NEFT Request',
          link: '/redeemrequest',
        },

      );
    }
    if (permissions?.is_gift_tab == 1 || permissions?.is_gift_tab === true || permissions?.is_gift_tab === '1') {
      updatedTenantPages.push(
        {
          name: 'Gift Request',
          link: '/redeemrequestgift',
        }
      );
    }
    setRedReqPages(updatedTenantPages);
    // eslint-disable-next-line
  }, [permissions]);

  return redReqPages;
};

export default RedReqList;
